import { Controller } from 'stimulus';

export default class extends Controller {
  static outlets = ["dashboard--orchestrator"];

  static targets = [
    "checkbox"
  ];

  connect() {
    this.boundHandleProgramsUpdate = this.handleProgramsUpdate.bind(this);
    this.boundHandleSelectAll = this.handleSelectAll.bind(this);
    this.boundDeselectAll = this.handleDeselectAll.bind(this);

    document.addEventListener(
      'promote:dashboard:programs-updated',
      this.boundHandleProgramsUpdate
    );

    document.addEventListener(
      'promote:checkbox-select-all',
      this.boundHandleSelectAll
    );

    document.addEventListener(
      'promote:checkbox-deselect-all',
      this.boundDeselectAll
    );
  }

  disconnect() {
    document.removeEventListener(
      'promote:dashboard:programs-updated',
      this.boundHandleProgramsUpdate
    );

    document.removeEventListener(
      'promote:checkbox-select-all',
      this.boundHandleSelectAll
    );

    document.removeEventListener(
      'promote:checkbox-deselect-all',
      this.boundDeselectAll
    );
  }

  handleSelectAll(event) {
    event.preventDefault();

    const programIds = Array.from(this.checkboxTargets).map(c => c.value);

    if (this.hasDashboardOrchestratorOutlet) {
      this.dashboardOrchestratorOutlet.toggleMultipleProgramSelection(programIds);
    }
  }

  handleDeselectAll(event) {
    event.preventDefault();

    if (this.hasDashboardOrchestratorOutlet) {
      this.dashboardOrchestratorOutlet.toggleMultipleProgramSelection([]);
    }
  }

  toggleSelection(event) {
    const checkbox = event.target;
    const programId = checkbox.value;

    if (this.hasDashboardOrchestratorOutlet) {
      this.dashboardOrchestratorOutlet.toggleProgramSelection(programId);
    }
  }

  handleProgramsUpdate(event) {
    const { programIds } = event.detail;

    this.updateCheckboxStates(programIds);
  }

  updateCheckboxStates(selectedProgramIds) {
    this.checkboxTargets.forEach(checkbox => {
      const isSelected = selectedProgramIds.includes(checkbox.value);
      if (checkbox.checked !== isSelected) {
        checkbox.checked = isSelected;
      }
    });
  }

  // TODO: Need to sync these with the downstream stuff, but it'll require
  // finding these matching rows for each selected element in a nicer way than
  // just grabbing the checkbox + querySelecting our way thru 
  highlightRow(event) {
    event.currentTarget.classList.add('bg-gray-50');
  }

  unhighlightRow(event) {
    event.currentTarget.classList.remove('bg-gray-50');
  }
}
